// @flow
import React, { useContext } from 'react';
import { DateCategoryHeading } from '../ui/date-category-heading/date-category-heading';
import { Draggable } from 'react-beautiful-dnd';
import Button from '@material-ui/core/Button';
import { articleEdit } from '../articles/edit.util';
import { ApiContext } from './context';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

export const HomeItem = props => {
	const { node, index, onRemove } = props;
	return (
		<Draggable index={index} key={index} draggableId={node.id}>
			{provided => (
				<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
					<Card title={node.mainPageOrder} className="item">
						<CardContent style={{ padding: 10, fontWeight: 500, whiteSpace: 'wrap' }}>
							<DateCategoryHeading date={node.availableAt} categoryName={node.categoryName} />
							<div>{node.title}</div>
						</CardContent>
						<div className="overlay">
							<Button color="primary" variant="contained" classNiname="button_tool" onClick={onRemove(node.id)}>
								убрать с главной
							</Button>
						</div>
					</Card>
				</div>
			)}
		</Draggable>
	);
};

export const HomeItemContainer = props => {
	const { refetch } = useContext(ApiContext);
	const handleRemove = (id: string) => () => {
		articleEdit(
			id,
			props.section,
			input => (input.mainPageOrder = 0),
			() => refetch(),
		);
	};
	return <HomeItem {...props} onRemove={handleRemove} />;
};



// WEBPACK FOOTER //
// src/components/home/home_item.js